import memoize from 'lodash/memoize';
import {
	evaluateFormatRule,
	isFormatRuleEvaluationSupported,
} from '@atlassian/jira-business-fields/src/common/evaluate-format-rule';
import type { ListIssueFieldTransformed } from '@atlassian/jira-business-fields/src/common/types.tsx';
import type { MappedRule } from '../../common/types';

export const getColorFormatRules = memoize(
	({
		rules,
		issueFields,
	}: {
		rules?: MappedRule[];
		issueFields?: ListIssueFieldTransformed[];
	}): MappedRule | null => {
		if (!issueFields || !rules) return null;

		const issueFieldsById: { [key: string]: ListIssueFieldTransformed } = {};
		issueFields.forEach((field) => {
			issueFieldsById[field.fieldId] = field;
		});

		for (const rule of rules) {
			const { operator, value, fieldId } = rule;
			if (operator && fieldId) {
				const ruleField = issueFieldsById[fieldId];

				if (isFormatRuleEvaluationSupported(ruleField?.type)) {
					const ruleResult = evaluateFormatRule(ruleField?.type, {
						field: ruleField,
						operator,
						value,
					});

					if (ruleResult) {
						return rule;
					}
				}
			}
		}

		return null;
	},
	(args) => JSON.stringify(args),
);
